import { Component, ElementRef, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { isUndefined } from 'src/app/services/codeUtils';
import { Navigator } from './../../menu/navigator'
import { NavOverriderService } from '../../../services/navOverrider/nav-overrider.service';

@Component({
	selector: 'custom-navbar',
	templateUrl: './custom-navbar.component.html'
})
export class CustomNavbarComponent implements OnInit, OnDestroy {

	private navOverrideSubcriber;
	@ViewChild('theNavBar') theNavBar: ElementRef;

	@Input() extendCloseBtnFunction: any;
	@Input() hideBackButton: boolean;
	@Input() overrideBackBtnFunction: any;
	@Input() overrideCloseBtnFunction: any;
	@Input() titlelabel: string;
	@Input() hideCloseButton: boolean;

	constructor(
		public navigator: Navigator,
		public navOverride: NavOverriderService
	) { }

	ngOnInit(): void {
		try {
			if (this.navOverrideSubcriber) this.navOverrideSubcriber.unsubscribe();
		} catch {
			console.log('Subcription error');
		}

		this.navOverrideSubcriber = this.navOverride
			.getCustomCloseFunction()
			.subscribe(customCloseFunction => {
				if (
					typeof customCloseFunction === 'function' ||
					customCloseFunction === undefined
				) {
					this.overrideCloseBtnFunction = customCloseFunction;
				}
			});
	}

	onBack() {

		if (!isUndefined(this.overrideBackBtnFunction)) {
			try {
				return this.overrideBackBtnFunction();
			} catch {
				return this.navigator.back();
			}
		}

		return this.navigator.back();
	}


	onClose() {

		if (!isUndefined(this.overrideCloseBtnFunction)) {
			try {
				return this.overrideCloseBtnFunction();
			} catch (err) {
				return console.error(err);
			}
		}

		return this.onCloseDefault();
	}

	onCloseDefault() {
		if (!isUndefined(this.extendCloseBtnFunction)) {
			try {
				return this.extendCloseBtnFunction()
			}
			catch (error) {
				return console.error(error);
			}
		}
		return this.navigator.dismissAll();
	}

	ngOnDestroy() {
		try {
			this.navOverrideSubcriber?.unsubscribe();
		} catch (error) {
			console.error('Failed to unsubscribe Navbar:', error);
		}
	}

}
